module.exports = __webpack_public_path__ + "/login_ui/img/sg-cef0bd5515006440ac28255824b1ad0e.svg";